import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { designTokens } from '../../../theming/design-tokens';

const { colors, spacing, borderRadius, mixins, typography } = designTokens;

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      width: '100%',
      border: `1px solid ${colors.border.light}`,
      borderRadius: borderRadius.base,
      padding: theme.spacing(1),
    },
    headerContainer: {
      ...mixins.flexBetween,
      padding: theme.spacing(1),
      backgroundColor: colors.background.primary,
      marginBottom: theme.spacing(1),
    },
    restaurantInfo: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(2),
    },
    restaurantId: {
      fontSize: typography.fontSize['2xl'],
      fontWeight: typography.fontWeight.semibold,
      color: colors.neutral.gray800,
    },
    statusChip: {
      color: colors.neutral.white,
      fontWeight: typography.fontWeight.semibold,
    },
    statusChipOpen: {
      backgroundColor: colors.semantic.success,
    },
    statusChipClosed: {
      backgroundColor: colors.semantic.error,
    },
    statusChipOther: {
      backgroundColor: colors.semantic.warning,
    },
    weekSelector: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      padding: theme.spacing(1, 2),
      border: `1px solid ${colors.border.light}`,
      borderRadius: theme.shape.borderRadius,
      backgroundColor: colors.background.primary,
    },
    editButton: {
      backgroundColor: colors.neutral.gray800,
      color: colors.neutral.white,
      fontWeight: typography.fontWeight.semibold,
      textTransform: 'none',
      borderRadius: borderRadius.base,
      '&:hover': {
        backgroundColor: colors.interactive.primaryHover,
      },
    },
    contentContainer: {
      backgroundColor: colors.background.primary,
      padding: theme.spacing(0.5),
    },
    franchiseGroupText: {
      marginTop: spacing.xs,
      color: colors.neutral.gray600,
    },
    controlsContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: spacing.sm,
    },
    weekSelectorInner: {
      display: 'flex',
      alignItems: 'center',
      gap: spacing.xs,
    },
    iconButton: {
      padding: spacing.xs,
    },
    weekText: {
      margin: `0 ${spacing.xs}`,
      cursor: 'pointer',
      padding: `${spacing.xs} ${spacing.sm}`,
      borderRadius: borderRadius.base,
      transition: 'background-color 0.2s',
      '&:hover': {
        backgroundColor: colors.background.disabled,
      },
    },
    calendarDialog: {
      height: 'fit-content',
      width: '400px',
      overflow: 'hidden',
    },
    calendarDialogTitle: {
      marginTop: spacing.sm,
      color: colors.neutral.gray600,
    },
    calendarDialogContent: {
      padding: '0',
      overflow: 'hidden',
    },
    calendarPaper: {
      textAlign: 'left',
      overflow: 'hidden',
    },
  }),
);
